import { render, staticRenderFns } from "./Detail2.vue?vue&type=template&id=1d221431&scoped=true&"
import script from "./Detail2.vue?vue&type=script&lang=js&"
export * from "./Detail2.vue?vue&type=script&lang=js&"
import style0 from "./Detail2.vue?vue&type=style&index=0&id=1d221431&scoped=true&lang=css&"
import style1 from "./Detail2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d221431",
  null
  
)

export default component.exports